import _css from "@emotion/css";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/core";
function SelectObject(_ref) {
  var size = _ref.size,
    primaryColor = _ref.primaryColor,
    hoverColor = _ref.hoverColor,
    testId = _ref.testId;
  var theme = useTheme();
  return ___EmotionJSX("svg", {
    css: /*#__PURE__*/_css({
      display: "block",
      fill: primaryColor,
      transition: hoverColor ? theme.transitions.icon : null,
      ":hover": _objectSpread({}, hoverColor && {
        fill: hoverColor
      })
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9zZWxlY3Qtb2JqZWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNNIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy9zZWxlY3Qtb2JqZWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHVzZVRoZW1lIGZyb20gXCIuLi9ob29rcy91c2VUaGVtZVwiO1xuXG5mdW5jdGlvbiBTZWxlY3RPYmplY3QoeyBzaXplLCBwcmltYXJ5Q29sb3IsIGhvdmVyQ29sb3IsIHRlc3RJZCB9KSB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcblxuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIGZpbGw6IHByaW1hcnlDb2xvcixcbiAgICAgICAgdHJhbnNpdGlvbjogaG92ZXJDb2xvciA/IHRoZW1lLnRyYW5zaXRpb25zLmljb24gOiBudWxsLFxuICAgICAgICBcIjpob3ZlclwiOiB7XG4gICAgICAgICAgLi4uKGhvdmVyQ29sb3IgJiYgeyBmaWxsOiBob3ZlckNvbG9yIH0pLFxuICAgICAgICB9LFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGFyaWEtbGFiZWw9XCJTZWxlY3Qgb2JqZWN0XCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGggZD1cIk0xNCAxNGwxNCAzLjUtNS4yIDMuNSA0Ljg2IDQuOTNhLjQ5LjQ5IDAgMDEwIC43bC0xIDFhLjUuNSAwIDAxLS43IDBMMjEgMjIuNzcgMTcuNSAyOHpcIiAvPlxuICAgICAgPHBhdGggZD1cIk0xMiAyNkg2YTIgMiAwIDAxLTItMlY2YTIgMiAwIDAxMi0yaDE4YTIgMiAwIDAxMiAydjZhMSAxIDAgMDEtMiAwVjZINnYxOGg2YTEgMSAwIDAxMCAyelwiIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblNlbGVjdE9iamVjdC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIGhvdmVyQ29sb3I6IFByb3BUeXBlcy5zdHJpbmcsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFNlbGVjdE9iamVjdDtcbiJdfQ== */"),
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Select object",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M14 14l14 3.5-5.2 3.5 4.86 4.93a.49.49 0 010 .7l-1 1a.5.5 0 01-.7 0L21 22.77 17.5 28z"
  }), ___EmotionJSX("path", {
    d: "M12 26H6a2 2 0 01-2-2V6a2 2 0 012-2h18a2 2 0 012 2v6a1 1 0 01-2 0V6H6v18h6a1 1 0 010 2z"
  }));
}
SelectObject.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
  testId: PropTypes.string
};
export default SelectObject;